import React, { useState, useEffect, useContext, useRef } from "react";

import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import DwgViewerModePill from "./components/DwgViewerModePill";
import DwgPdfViewer from "./components/DwgPdfViewer";
import DwgAutodeskViewer from "./components/DwgAutodeskViewer";
import DwgFinderViewer from "./components/DwgFinderViewer";


export default function DwgInteraction() {
	  
  const [viewerMode, setViewerMode] =
      useState("pdf");
	  
 
	  
	  
  
  // ---------------- STYLES ----------------

  const pageContainer = {
    position: "relative",
    minHeight: "100vh",
    overflowX: "hidden",
    overflowY: "auto"
  };

  const pageBackground = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "white",
    zIndex: 0,
    pointerEvents: "none"
  };

  const thisContainer = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "50px",
    minHeight: "100vh",
    position: "relative",
    zIndex: 1
  };

  const mainContent = {
	display:'flex',
    position: "fixed",
    left: "60px",
    top: "0px",
    right: "0px",
    bottom: "0px"
  };


  const thisframe = {
	width:'100%',
	height:'100%'
  };
  
  
 
  
  


  // ---------------- RENDER ----------------

  return (
    <div style={pageContainer}>

      <div style={pageBackground} />

      <div style={thisContainer}>

        <Header transitionHide={true}/>
        <LeftMenu />

		<div style={mainContent}>

			<DwgViewerModePill
			    viewerMode={viewerMode}
			    setViewerMode={setViewerMode}
			/>


		    {viewerMode === "pdf" &&
		         <DwgPdfViewer />
		    }


		    {viewerMode === "finder" &&
		       <DwgFinderViewer />
		    }


			{viewerMode === "autodesk" &&
				<DwgAutodeskViewer />
			}
		</div>
      </div>
	 
	
    </div>
  );
  
  
}